import { Outlet, NavLink, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/events", label: "Events" },
  { to: "/admin/posts", label: "Posts" },
  { to: "/admin/team-members", label: "Team members" },
  { to: "/admin/members", label: "Members" },
  { to: "/admin/partners", label: "Partners" },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem('bah_cms_key');
    navigate('/admin/login');
  };

  const isLoggedIn = !!sessionStorage.getItem('bah_cms_key');

  return (
    <div className="flex min-h-screen bg-gray-100">
      {isLoggedIn && (
        <aside className="w-56 shrink-0 bg-bahbrown text-white flex flex-col">
          <div className="px-6 py-5 font-bold text-bahyellow text-lg border-b border-white/20">
            BAH Admin
          </div>
          <nav className="flex-1 py-4">
            {navLinks.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `block px-6 py-2.5 text-sm hover:bg-white/10 ${isActive ? 'bg-white/20 font-semibold' : ''}`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
          <button
            onClick={handleLogout}
            className="px-6 py-4 text-sm text-left hover:bg-white/10 border-t border-white/20"
          >
            Log out
          </button>
        </aside>
      )}
      <main className="flex-1 p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
